import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import {
  AlertService,
  FormBase,
  FormBaseControlService,
  GTagService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { AuthenticationService } from '../../../../_services/_iam/authentication-service.service';
import { User } from '@models/user';
import { ClientCredentialsService } from '../../../../_services/client-credentials/client-credentials.service';
import { ClientCredentialsTokenService } from '../../../../_services/client-credentials/client-credentials-token.service';
import { Router, ActivatedRoute , RouterModule } from '@angular/router';
import { Location } from '@angular/common';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { UserDataService } from '../../../../_services/data-services/user-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreIputWithValidationComponent, MapfreButtonComponent],
  selector: 'app-send-email-form',
  templateUrl: './send-email-form.component.html',
  providers: [FormBaseControlService],
})
export class SendEmailFormComponent implements OnInit {
  @Input() emailPrefillParamater: string;
  @Input() inputs: FormBase<any>[] = [];
  @Input() inputValidation: boolean;
  passwordEmailForm: FormGroup;
  user: User = {};
  whereInTheProcess: string;

  @Output() showConfirmation: EventEmitter<boolean> = new EventEmitter();
  loader = false;
  isAcmic = false;
  constructor(
    private authService: AuthenticationService,
    private userDataService: UserDataService,
    private alertService: AlertService,
    private ipt: FormBaseControlService,
    private clientCredentialsService: ClientCredentialsService,
    private clientCredentialsTokenService: ClientCredentialsTokenService,
    public router: Router,
    private activeRoute: ActivatedRoute,
    private location: Location,
    private errorRedirectionService: ErrorRedirectionService,
    private gTagService: GTagService,
    private acmicService: AcmicService,
    private translate: TranslateService
  ) {}

  isValid(event): boolean {
    return (this.inputValidation = event === undefined ? false : event);
  }

  onGoBck() {
    this.location.back();
  }

  forgotPasswordSendEmailId(): void {
    const emailAddress = this.passwordEmailForm.controls.sendEmail.value;
    this.user.email = emailAddress;
    this.loader = true;
    if (this.user.email) {
      this.authService.forgotPasswordSendEmailId(this.user.email).subscribe(
        () => {
          this.gTagService.triggerFormLink('passwordEmailForm', 'true', '');
          this.loader = false;
          if (this.whereInTheProcess == 'profilepassword/:emailPrefill') {
            this.router.navigate(['/profilepassword', emailAddress]);
          } else {
            this.router.navigate(['/forgotpassword', emailAddress]);
          }

          this.userDataService.updateConfimationValue(true);
          this.showConfirmation.emit(true);
        },
        (error) => {
          this.gTagService.triggerFormLink(
            'passwordEmailForm',
            'false',
            this.translate.instant('SEND_EMAIL_ERROR')
          );
          this.loader = false;
          this.errorRedirectionService.errorHandler(
            error,
            'EMAIL_COULD_NOT_VALIDATE'
          );
        }
      );
    }
  }

  getEmailFromParamater(): void {
    this.passwordEmailForm = this.ipt.toFormGroup(this.inputs);
    this.passwordEmailForm.controls.sendEmail.setValue(
      this.emailPrefillParamater
    );
  }

  ngOnInit() {
    this.whereInTheProcess = this.activeRoute.snapshot.routeConfig.path;
    this.getEmailFromParamater();
    this.isAcmic = this.acmicService.isACMIC();
    if (!this.clientCredentialsTokenService.getToken()) {
      this.clientCredentialsService.getToken().subscribe();
    }
  }
}
